import cx from 'classnames'
import { useMemo } from 'react'
import { sample } from 'lodash'

import Styles from './VideosRow.module.scss'

import { useDebounce } from 'hooks/useDebounce'
import { useImageMenuContext } from '../ImageMenuContext'

import { getVideoMimeType } from 'components/Design/UploadsTab/components/StockVideosGallery'

import { Heading } from 'blaze-ui/Heading/Heading'
import { Carousel } from 'components/Carousel/Carousel'
import { Button } from 'blaze-ui/Button'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import { SelectableFile } from '../SelectableFile/SelectableFile'
import { useStockVideos, VIDEO_CATEGORIES } from 'hooks/queries/designer/useStockVideos'

export const VideosRowContent = () => {
  const { searchTerm, setProvider, toggleSelectedImage, selectedImages } = useImageMenuContext()
  const debouncedQuery = useDebounce(searchTerm, 500)

  const category = useMemo(() => sample(VIDEO_CATEGORIES), [])

  const { data } = useStockVideos({
    query: debouncedQuery,
    pageSize: 24,
    videoType: 'all',
    category: !debouncedQuery ? category : undefined,
  })

  const videos = data?.pages.flatMap((page) => page.videos) || []

  const videoFiles = videos.map((video) => ({
    id: video.id,
    url: video.videos.medium.url,
    source_url: video.videos.medium.url,
    thumbnail_url: video.videos.medium.thumbnail,
    duration: video.duration,
    variants: [],
    mime_type: video.videos.medium.mime_type ?? getVideoMimeType(video.videos.medium.url),
    title: video.id,
    preview_variant_url: video.videos.tiny.url,
  }))

  return (
    <div className={cx(Styles.row, Styles.videosRow, Styles.container)}>
      <div className={Styles.rowHeader}>
        <Heading level={4} color="var(--dark-80)">
          Stock Videos
        </Heading>
        <Button size="sm" variant="ghost" onPress={() => setProvider('videos')} data-testid="see-all-videos-button">
          See All
        </Button>
      </div>
      <div className={Styles.carouselContainer}>
        <Carousel offset={20}>
          {videoFiles.map((video) => (
            <SelectableFile
              key={video.id}
              onSelect={() => toggleSelectedImage({ ...video, provider: 'stockVideo' })}
              isSelected={selectedImages.some((i) => i.url === video.url)}
            >
              <img key={video.id} src={video.thumbnail_url} alt={video.thumbnail_url} />
              {video.duration && <VideoDuration duration={video.duration} />}
            </SelectableFile>
          ))}
        </Carousel>
      </div>
    </div>
  )
}

export const VideosRow = () => {
  const { hiddenProviders } = useImageMenuContext()

  if (hiddenProviders.includes('stockVideo')) return null

  return <VideosRowContent />
}
